import { Gift } from 'lucide-react';
import type { Passbook } from '@/shared/types';
import { accentStyle } from '../public/brand';
import { BenefitsCard } from '../public/participant/benefits-card';
import { ReferralBanner } from '../public/invite/referral-banner';
import { renderPush } from '../model/copy';
import type { MgmPublicRules } from '../model/types';

/**
 * Prévia ao vivo no formulário do master: usa os MESMOS componentes da página
 * do participante e do convite, então o que aparece aqui é o que o cliente vê.
 */
export function MgmPreview({
  passbook,
  rules,
  referrerPush,
  referredPush,
}: {
  passbook: Passbook | null;
  rules: MgmPublicRules;
  referrerPush: string;
  referredPush: string;
}) {
  const brand = {
    name: passbook?.organizationName ?? '',
    backgroundColor: passbook?.backgroundColor ?? null,
    foregroundColor: passbook?.foregroundColor ?? null,
  };
  const referrerAmount = rules.referrer.amountText || '…';
  const referredAmount = rules.referred.amountText || '…';

  return (
    <div className="space-y-4">
      <div>
        <p className="mb-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">No app do cliente</p>
        <div
          className="mgm-scope mx-auto w-full max-w-[20rem] overflow-hidden rounded-[2rem] border-4 border-foreground/80 bg-muted/40 shadow-glass"
          style={accentStyle(brand)}
        >
          <div className="mgm-hero px-4 pb-12 pt-5">
            <div className="flex items-center gap-3">
              <span className="grid size-11 place-items-center rounded-xl bg-white/20 ring-1 ring-white/30">
                <Gift className="size-5" />
              </span>
              <div className="min-w-0">
                <p className="truncate text-lg font-bold leading-tight">{rules.title}</p>
                <p className="line-clamp-2 text-xs opacity-90">{rules.subtitle}</p>
              </div>
            </div>
          </div>
          <div className="-mt-8 space-y-3 px-3 pb-4">
            {rules.referrer.enabled || rules.referred.enabled ? (
              <BenefitsCard rules={rules} />
            ) : (
              <p className="rounded-2xl bg-card p-4 text-center text-xs text-muted-foreground">
                Habilite uma recompensa para ver a prévia.
              </p>
            )}
            <div className="flex h-10 items-center justify-center rounded-xl bg-[#25D366] text-sm font-semibold text-white">
              Enviar no WhatsApp
            </div>
          </div>
        </div>
      </div>

      <div>
        <p className="mb-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">No convite (quem recebe o link)</p>
        <ReferralBanner referrerFirstName="João" rules={rules} />
      </div>

      <div className="space-y-2">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">Notificações</p>
        {rules.referrer.enabled ? (
          <div className="rounded-xl border border-border/60 bg-card p-3 text-sm">
            <p className="text-xs text-muted-foreground">Para quem indicou</p>
            {renderPush(referrerPush, { amount: referrerAmount, name: 'Maria S.' })}
          </div>
        ) : null}
        {rules.referred.enabled ? (
          <div className="rounded-xl border border-border/60 bg-card p-3 text-sm">
            <p className="text-xs text-muted-foreground">Para quem foi indicado</p>
            {renderPush(referredPush, { amount: referredAmount, name: 'João' })}
          </div>
        ) : null}
      </div>
    </div>
  );
}
